import React, { useState, useEffect } from "react";
import "./Other.css";
import CategoriesNav from "../categoriesNav/categoriesNav";
import { fetchData } from "../../Api/dataApi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Other = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    const fetchOther = async () => {
      try {
        const result = await fetchData("Other");
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOther();
  }, []);

  return (
    <div className="Other">
      <CategoriesNav />
      <h2 className="Other-title">{t("available_other")}</h2>

      {loading && <p>{t("loading")}</p>}
      {error && (
        <p style={{ color: "red" }}>
          {t("error_message")}: {error}
        </p>
      )}

      <div className="Other-container">
        {data.length === 0 && !loading && <p>{t("no_product")}</p>}

        {data.map((other) => (
          <div key={other.id || other._id} className="Other-card">
            <Link to={`/product/${other.id || other._id}`}>
              <img
                src={
                  Array.isArray(other.images) && other.images.length > 0
                    ? other.images[0]
                    : t("no_image")
                }
                alt={other.title || t("no_name")}
                className="Other-image"
              />
            </Link>
            <div className="Other-content">
              <h3 className="Other-name">
                {truncateText(other.title || t("no_name"), 6)}
              </h3>
              <p className="Other-description">
                {truncateText(other.description || t("no_description"), 6)}
              </p>
              <p className="Other-price">
                {t("price")}: {other.price || t("no_price")}
              </p>
              <p className="Other-location">
                {t("location")}: {other.location || t("no_location")}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Other;
